import React, { useEffect, useRef, useState } from "react";
import ChapterDataService from "../../services/ChapterService";

import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { TextField } from "@mui/material";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";

import "../styles/modalStyles.css";
import PageDetailsV2 from "./PageDetailsV2";
import ConfirmationModal from "../micro_components/ConfirmationModal";

import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import Dropzone from "../micro_components/DropZone";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import BasicDropZone from "../micro_components/BasicDropZone";
import BookDataService from "../../services/BookService";

const PageModalV2 = (props) => {
  const { bookId, chapterId, isOpen, onClose, initialChapter } = props;

  const [localChapter, setLocalChapter] = useState(initialChapter);

  const [localPages, setLocalPages] = useState([]);

  const [lastSavedPages, setLastSavedPages] = useState([]);

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(true);
  const [chapterType, setChapterType] = useState(
    initialChapter.audio ? "audio" : "video"
  );
  const [audioToUpload, setAudioToUpload] = useState();
  const [audioUploading, setAudioUploading] = useState(false);

  const [videoPoster, setVideoPoster] = useState("");
  const [posterURL, setPosterURL] = useState(null);

  const [thumbModal, setThumbModal] = useState(false);
  const thumbModalRef = useRef();
  const [cropper, setCropper] = useState();
  const [croppedImage, setCroppedImage] = useState();
  const cropperRef = useRef();
  const [newThumb, setNewThumb] = useState();
  const [previewPageTitle, setPreviewPageTitle] = useState(
    initialChapter.name || "Chapter name"
  );
  const [constrainThumb, setConstrainThumb] = useState(false);
  const [showCropper, setShowCropper] = useState(true);
  const [uploadingThumb, setUploadingThumb] = useState(false);
  const [menuWidth, setMenuWidth] = useState(300);
  const [chapterThumbHeight, setChapterThumbHeight] = useState(90);
  const [pageThumbHeight, setPageThumbHeight] = useState(70);
  const [doneUploadingChapterThumb, setDoneUploadingChapterThumb] =
    useState(false);
  const [hideGradient, setHideGradient] = useState(false);
  const [videoFolderLink, setVideoFolderLink] = useState(
    initialChapter.videoFolderLink
  );

  const thumbModalStyle = {
    // width: "500px",
    // height: "500px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    zIndex: 9999,
  };

  // ON LOAD
  useEffect(() => {
    getPagesFromBackend();

    BookDataService.getBookInfo(bookId)
      .then((res) => {
        console.log(res);
        setMenuWidth(res.data.bookInfo.menuWidth || 300);
        setChapterThumbHeight(res.data.bookInfo.chapterThumbHeight || 90);
        setPageThumbHeight(res.data.bookInfo.pageThumbHeight || 70);
      })
      .catch((e) => console.log(e));
  }, []);

  // useEffect(() => {
  //   console.log(localPages);
  // }, [localPages]);

  //GET PAGES FROM BACKEND
  const getPagesFromBackend = () => {
    ChapterDataService.getChapterPages(chapterId)
      .then((response) => {
        // console.log("PAGES IN CHAPTER FROM BACKEND: ", response.data);
        let repData = response.data.pages;

        repData.sort(function (a, b) {
          return a.page_number - b.page_number;
        });

        for (let i = 0; i < repData.length; i++) {
          repData[i].renderKey = i;
          repData[i].content = null;
        }
        setLocalPages(repData);
        setLastSavedPages(response.data.pages);
        if (response.data.posterLink)
          setPosterURL(
            `https://d24hdgytax3x03.cloudfront.net/${bookId}/chapterPosters/${response.data.posterLink}`
          );
      })
      .catch((e) => {
        console.log("error getting chapters in book: ", e);
      });
  };

  //   MAKE NEW PAGE -- APPEND TO END
  const makeNewPageOnEnd = () => {
    // console.log("make new page");
    // console.log(localPages.length);
    const page = {
      page_number: localPages.length + 1,
      name: null,
      id: null,
      contentImageLink: null,
      renderKey: localPages.length + 1,
      content: null,
    };
    // //make new page array and append new page
    let repData = [...localPages];
    repData.push(page);
    // set pages to new page array
    setLocalPages(repData);
  };

  // SAVE ORDER, NEW PAGES, AND IMAGES
  const saveChanges = () => {
    //upload each object, perhaps with its images all at once?

    setConfirmationOpen(true);
    setConfirmationLoading(true);

    ChapterDataService.uploadPageData(localChapter.id, localPages)
      .then((response) => {
        console.log("saved page data changes: ", response.data);
        for (let i = 0; i < localPages.length; i++) {
          setConfirmationLoading(true);
          // console.log(localPages[i]);
          if (localPages[i].content) {
            setConfirmationLoading(true);
            console.log("saving content for page: ", localPages[i]);
            let savedId = 0;
            if (!localPages[i].id) {
              savedId = response.data.filter((b) => {
                return b.page_number === localPages[i].page_number;
              })[0].id;
            } else {
              savedId = localPages[i].id;
            }
            console.log("savedId: ", savedId);
            ChapterDataService.uploadPageContent(
              savedId,
              localPages[i].content
            ).then(() => setConfirmationLoading(false));
          }
          setConfirmationLoading(false);
        }
      })
      .catch((e) => {
        console.log("error uploading page data: ", e);
      });

    //remove render key from uploading
    // let pagesToSave = [...localPages];

    // console.log(pagesToSave);

    // for (let i = 0; i < pagesToSave.length; i++) {
    //   delete pagesToSave[i].renderKey;
    //   delete pagesToSave[i].content;
    // }

    let chapter = {
      id: localChapter.id,
      name: localChapter.name,
      videoLink: localChapter.videoLink,
      videoFolderLink: videoFolderLink,
      chapter_type: localChapter.chapter_type || chapterType,
      audio: chapterType === "video" ? false : true,
    };

    ChapterDataService.uploadChapterDetails(localChapter.id, chapter)
      .then(() => {
        console.log("saved changes");
      })
      .catch((e) => {
        console.log("error uploading chapters: ", e);
      });

    ChapterDataService.postVideoPoster(chapterId, videoPoster)
      .then((res) => {
        console.log("Uploaded video poster:", res.data);
      })
      .catch((e) => {
        console.log("Error uploading video poster:", e);
      });
  };

  //   REVERT TO LAST PAGE CHANGES
  const cancelChanges = () => {
    console.log("cancelling");
    setLocalPages(lastSavedPages);
    setLocalChapter(initialChapter);
    getPagesFromBackend();
    onClose();
  };

  //video name change
  const handleChapterChange = (event) => {
    const { name, value } = event.target;
    setLocalChapter({ ...localChapter, [name]: value });
  };

  const changeType = (e) => {
    setChapterType(e.target.value);
  };

  const movePageUp = (pageNum) => {
    //if at top, do nothing
    if (pageNum - 1 === 0) {
      return;
    } else {
      console.log("moving up: ", localPages[pageNum - 1]);
      console.log("moving down: ", localPages[pageNum - 2]);
      var repData = [...localPages];
      let pageToMoveDown = localPages[pageNum - 2];

      // SWAP
      repData[pageNum - 2] = localPages[pageNum - 1];
      repData[pageNum - 1] = pageToMoveDown;

      repData = reOrderPages(repData);

      setLocalPages(repData);
    }
  };

  const movePageDown = (pageNum) => {
    if (pageNum === localPages.length) {
      return;
    } else {
      var repData = [...localPages];
      let pageToMoveUp = localPages[pageNum];

      // swap
      repData[pageNum - 1] = pageToMoveUp;
      repData[pageNum] = localPages[pageNum - 1];

      repData = reOrderPages(repData);

      setLocalPages(repData);
    }
  };

  //renumber pages on page order change
  const reOrderPages = (pages) => {
    for (let i = 0; i < pages.length; i++) {
      pages[i].page_number = i + 1;
    }
    return pages;
  };

  const removePage = (pageNum) => {
    let repData = [...localPages];

    console.log(pageNum);

    for (let i = pageNum - 1; i < repData.length - 1; i++) {
      repData[i] = localPages[i + 1];
      repData[i].page_number = i + 1;
    }

    repData.pop();

    console.log(repData);

    setLocalPages(repData);
  };

  const setPageImage = (pageNum, data) => {
    console.log(localPages);
    let newData = [...localPages];

    let newPage = [...localPages][pageNum - 1];

    newPage.content = data;

    newData[pageNum - 1] = newPage;

    // newData[pageNum - 1].content = data;

    setLocalPages(newData);
  };

  // const uploadPageData = () => {

  // }

  const handlePosterDrop = (data) => {
    setVideoPoster(data);
  };

  const handleDeleteAsset = () => {
    setAudioToUpload(null);
  };

  const handleUploadAudio = () => {
    setAudioUploading(true);
    ChapterDataService.uploadAudioFile(localChapter.id, audioToUpload)
      .then((response) => {
        console.log("saved new audio file: ", response.data);
        setAudioUploading(false);
      })
      .catch((e) => {
        setAudioUploading(false);
        console.log("error uploading chapters: ", e);
      });
  };

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
  };

  const handleThumbModalClickOut = (e) => {
    if (!thumbModalRef.current.contains(e.target)) {
      setThumbModal(false);
      setNewThumb();
    }
  };

  useEffect(() => setDoneUploadingChapterThumb(false), [thumbModal]);

  const handleThumbChange = (e) => {
    if (e.target.files.length === 0) return;
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setNewThumb(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const toggleCropper = () => {
    setShowCropper(false);
    setTimeout(() => setShowCropper(true), 10);
  };

  const handleThumbUpload = () => {
    setCroppedImage(
      cropper
        .getCroppedCanvas({
          width: menuWidth * 2,
          height: chapterThumbHeight * 2,
          imageSmoothingQuality: "high",
        })
        .toDataURL()
    );
  };

  useEffect(() => {
    if (croppedImage) {
      var arr = croppedImage.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      const data = new FormData();
      data.append("file", new File([u8arr], "test", { type: "image/png" }));
      setUploadingThumb(true);
      ChapterDataService.uploadChapterThumbnail(chapterId, data).then(() => {
        setUploadingThumb(false);
        setDoneUploadingChapterThumb(true);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [croppedImage]);

  return (
    <>
      <Modal open={isOpen} onClose={onClose} style={{}} className="page-modal">
        <div className="page-modal-content">
          <div className="chapter-type-radio-group">
            <FormControl>
              <FormLabel>Chapter type</FormLabel>
              <RadioGroup
                row
                aria-label="chapter-type"
                defaultValue={chapterType}
                name="chapter_type"
                onChange={changeType}
              >
                <FormControlLabel
                  value="video"
                  control={<Radio />}
                  label="Video"
                />
                <FormControlLabel
                  value="audio"
                  control={<Radio />}
                  label="Audio only"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="page-modal-title">
            <TextField
              label="Chapter Name"
              value={localChapter.name}
              size="small"
              variant="filled"
              name="name"
              onChange={handleChapterChange}
            />
          </div>

          <Button
            variant="contained"
            color="primary"
            onClick={() => setThumbModal(true)}
            style={{ width: "fit-content", height: "fit-content" }}
          >
            Chapter thumbnail
          </Button>
          {chapterType === "video" && (
            <>
              <div className="page-modal__video-link">
                <TextField
                  label="Video Link"
                  value={localChapter.videoLink}
                  size="small"
                  variant="filled"
                  name="videoLink"
                  onChange={handleChapterChange}
                />
                <TextField
                  label="Video Folder Link"
                  value={videoFolderLink}
                  size="small"
                  variant="filled"
                  name="chapterVideo"
                  onChange={(e) => setVideoFolderLink(e.target.value)}
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Dropzone
                  originalFile={posterURL}
                  label={"Video poster"}
                  setFileData={handlePosterDrop}
                  width={220}
                  height={110}
                />
              </div>
            </>
          )}
          {chapterType === "audio" && (
            <div className="chapter-dropzone-container">
              <span className="chapter-audio-label">Chapter audio</span>
              <div className="chapter-dropzone">
                <BasicDropZone
                  prepareFile={setAudioToUpload}
                  fileReady={Boolean(audioToUpload)}
                  uploadFunc={handleUploadAudio}
                  uploading={audioUploading}
                  initialFileName={initialChapter.audioLink}
                  handleDelete={handleDeleteAsset}
                />
              </div>
            </div>
          )}

          <div className="page-modal-main-area">
            {localPages.map((page, index) => {
              return (
                <PageDetailsV2
                  key={page.renderKey}
                  bookId={bookId}
                  page={page}
                  removePage={removePage}
                  insertPageAfter={() => console.log("insert page")}
                  movePageDown={movePageDown}
                  movePageUp={movePageUp}
                  setPageImage={setPageImage}
                  chapterId={chapterId}
                  menuWidth={menuWidth}
                  pageThumbHeight={pageThumbHeight}
                />
              );
            })}
          </div>
          <div style={{ margin: "0 10px 0 auto" }}>
            <Button
              color="primary"
              onClick={makeNewPageOnEnd}
              startIcon={<AddBoxOutlinedIcon />}
            >
              ADD PAGE
            </Button>
          </div>
          <div className="page-modal-buttons">
            <Button
              style={{ marginLeft: "15px" }}
              color="primary"
              onClick={saveChanges}
            >
              Confirm
            </Button>
            <Button
              style={{ marginRight: "-15px" }}
              color="secondary"
              onClick={cancelChanges}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      {confirmationOpen && (
        <ConfirmationModal
          title="Changes Saved!"
          isOpen={confirmationOpen}
          onClose={handleConfirmationClose}
          isLoading={confirmationLoading}
        />
      )}
      <Modal
        open={thumbModal}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#00000050",
          zIndex: 99999,
        }}
        onMouseDown={handleThumbModalClickOut}
      >
        <div
          className="thumbnail-modal"
          ref={thumbModalRef}
          style={thumbModalStyle}
        >
          <div>
            <input
              type="file"
              onChange={handleThumbChange}
              style={{ marginBottom: "1rem" }}
            />
          </div>
          {newThumb && (
            <div>
              <input
                type="checkbox"
                id="constrain"
                style={{ marginRight: "0.5rem" }}
                value={constrainThumb}
                onChange={(e) => {
                  setConstrainThumb(e.target.checked);
                  toggleCropper();
                }}
              />
              <label htmlFor="constrain">Constrain crop to image bounds</label>
            </div>
          )}
          {showCropper ? (
            <Cropper
              style={{ width: 500, height: 400, margin: "0 auto" }}
              ref={cropperRef}
              onInitialized={(instance) => {
                setCropper(instance);
              }}
              preview=".crop-preview"
              src={newThumb}
              aspectRatio={menuWidth / chapterThumbHeight || 3.333}
              viewMode={constrainThumb ? 2 : 0}
              dragMode="move"
              restore
              modal
              highlight
            />
          ) : (
            <div style={{ width: 500, height: 400 }} />
          )}
          <div
            style={{
              display: newThumb ? "block" : "none",
            }}
          >
            <hr />
            <div>
              <span style={{ fontSize: "1.4rem", fontWeight: 600 }}>
                Preview
              </span>
              <div style={{ marginTop: "0.5rem" }}>
                <span>Title: </span>
                <input
                  type="text"
                  value={previewPageTitle}
                  onChange={(e) => setPreviewPageTitle(e.target.value)}
                />
              </div>
              <label style={{ fontSize: "0.9rem", marginTop: "0.5rem" }}>
                <input
                  type="checkbox"
                  style={{ marginRight: "0.25rem" }}
                  checked={hideGradient}
                  onChange={(e) => {
                    setHideGradient(e.target.checked);
                  }}
                />
                <span
                  style={{
                    textDecoration: "underline",
                    textDecorationStyle: "dotted",
                  }}
                  title="To hide it in the reader, go to Edit Details and open the same menu for changing the thumbnail size"
                >
                  Hide gradient (Preview only!)
                </span>
              </label>
            </div>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  position: "relative",
                  width: menuWidth,
                  height: chapterThumbHeight,
                  margin: "1rem auto 0 auto",
                }}
              >
                <div
                  className="crop-preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    position: "relative",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    background: hideGradient
                      ? null
                      : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                    overflow: "hidden",
                  }}
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    height="28.8px"
                    width="28.8px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="white"
                      strokeWidth="0"
                      d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                    ></path>
                  </svg>
                  <span
                    style={{
                      fontFamily: '"Roboto condensed", sans-serif',
                      color: "white",
                      fontWeight: 800,
                      fontSize: "22.4px",
                      lineHeight: "22.4px",
                      maxWidth: "60%",
                      marginLeft: "8px",
                      textTransform: "uppercase",
                    }}
                  >
                    {previewPageTitle}
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
              }}
            >
              <Button
                disabled={uploadingThumb}
                color="primary"
                onClick={() => {
                  doneUploadingChapterThumb
                    ? setThumbModal(false)
                    : handleThumbUpload();
                }}
              >
                {uploadingThumb
                  ? "Uploading"
                  : doneUploadingChapterThumb
                  ? "Done"
                  : "Upload"}
              </Button>
              {!doneUploadingChapterThumb && (
                <Button
                  color="secondary"
                  onClick={() => {
                    setThumbModal(false);
                    setNewThumb();
                  }}
                >
                  Cancel
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PageModalV2;
